import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteFromCart, deleteItemFromCart, getItemsCart } from "../../actions/cartActions";
import Navbar from "../../components/Navbar/Navbar";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Footer from "../../components/Footer/Footer";

const CartView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { cartItem, cart } = useSelector((state) => state.cartReducer);
  const { token } = useSelector((state) => state.authReducer);

  const stateCartId = location?.state?.cartId;
  const fallbackCartId = cart?.id;
  const effectiveCartId = useMemo(() => stateCartId || fallbackCartId, [stateCartId, fallbackCartId]);

  const [quantityUpdates, setQuantityUpdates] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);

  const parseUserId = useMemo(() => {
    try { return token && token !== "undefined" ? JSON.parse(token)?.id ?? null : null; }
    catch { return null; }
  }, [token]);

  const deleteItem = async (cartItemId) => {
    if (!parseUserId) return;
    await dispatch(deleteItemFromCart(cartItemId));
    // also decrement header counter
    await dispatch(deleteFromCart(parseUserId, cart?.quantity ?? 0));
    // Refresh list
    if (effectiveCartId) dispatch(getItemsCart(effectiveCartId));
  };

  const calculateDiscount = (q) => {
    if (q >= 10) return 0.07;
    if (q >= 5) return 0.05;
    if (q >= 0) return 0.03;
    return 0;
  };

  const calcTotal = () => {
    let total = 0;
    (cartItem || []).forEach((ci) => {
      const q = quantityUpdates[ci.id] ?? ci.quantity ?? 0;
      const d = calculateDiscount(q);
      const price = ci.product_details?.price ?? 0;
      total += (price * (1 - d)) * q;
    });
    const t = Number.isFinite(total) ? total : 0;
    setTotalPrice(t.toFixed(2));
    return t;
    };

  useEffect(() => {
    if (effectiveCartId) {
      dispatch(getItemsCart(effectiveCartId));
    }
  }, [dispatch, effectiveCartId]);

  useEffect(() => {
    calcTotal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItem, quantityUpdates]);

  const handleCheckout = () => {
    if (!effectiveCartId) return;
    navigate("/checkout", { state: { cartId: effectiveCartId, totalPrices: totalPrice } });
  };

  return (
    <>
      <Navbar />
      <Container>
        <h1 className="mt-3">Your Cart Items</h1>
        <Row>
          {(cartItem || []).map((item, index) => {
            const { id, product_details, quantity } = item;
            const q = quantityUpdates[id] !== undefined ? quantityUpdates[id] : quantity;
            const d = calculateDiscount(q);
            const unit = (product_details?.price ?? 0) * (1 - d);
            const line = unit * q;

            return (
              <Col key={id || index} xs={12} sm={6} md={4} lg={3}>
                <Card className="shadow mt-4 h-100">
                  <Card.Body className="d-flex flex-column">
                    <Card.Title>{index + 1}.</Card.Title>
                    {product_details?.thumbnail && (
                      <Card.Img
                        src={product_details.thumbnail}
                        alt={`thumbnail-${index}`}
                        style={{ height: 120, objectFit: "cover" }}
                      />
                    )}
                    <div className="d-flex flex-column mt-2">
                      <Card.Title className="h6">{product_details?.title}</Card.Title>
                      <Card.Text className="mb-2">
                        <div><strong>Price:</strong> ₦{unit.toFixed(2)}</div>
                        <div><strong>Line Total:</strong> ₦{line.toFixed(2)}</div>
                        <div><strong>Item Added:</strong> {quantity}×</div>
                      </Card.Text>

                      <Button variant="danger" onClick={() => deleteItem(id)} className="mt-auto">
                        Delete
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>

      <Container className="mt-3 pb-4 pt-3 d-flex align-items-center gap-3">
        <h3 className="mb-0">Total Price: ₦{totalPrice}</h3>
        <Button className="p-3" variant="primary" onClick={handleCheckout}>
          Proceed to Checkout
        </Button>
      </Container>
      <Footer />
    </>
  );
};

export default CartView;
